import {Button} from '@mantine/core';
import {AiOutlineImport} from 'react-icons/ai';

import {useImportCodePipelineMutation} from '../hooks/useCodePipelinesQuery';
import {useCodePipelinesSelection} from '../hooks/useCodePipelinesSelection.ts';

export const ImportRecordButton = () => {

    const importCodePipelineMutation = useImportCodePipelineMutation();

    const {
        selection,
        handleClearSelection,
    } = useCodePipelinesSelection();

    const recordNames = Object.keys(selection).filter(name => selection[name] === true);
    const disabled = recordNames.length === 0;

    const handleImport = async () => {
        for (const name of recordNames) {
            await importCodePipelineMutation.mutateAsync(name);
        }
        handleClearSelection();
    };

    return (
        <Button
            variant='outline'
            disabled={disabled}
            loading={importCodePipelineMutation.isPending}
            leftSection={<AiOutlineImport/>}
            onClick={handleImport}
        >
            Import
        </Button>
    );
};
